import { splitSeconds } from '~/lib/countdown'
import { m } from '~/paraglide/messages'

function pad(n: number) {
  return String(n).padStart(2, '0')
}

function Tile(props: { value: string; label: string }) {
  return (
    <div class="flex size-[92px] flex-col items-center justify-center rounded-[10px] bg-white/30">
      <span class="text-[38px] font-bold leading-[45px] text-white">
        {props.value}
      </span>
      <span class="text-[17px] leading-[20px] text-white">{props.label}</span>
    </div>
  )
}

// The day : hour : min countdown tiles of the detail view's pending state.
export function CountdownTiles(props: { totalSeconds: number }) {
  const parts = () => splitSeconds(props.totalSeconds)
  return (
    <div class="flex w-full items-center justify-between">
      <Tile value={pad(parts().day)} label={m.day()} />
      <span class="text-[26px] leading-none text-white">:</span>
      <Tile value={pad(parts().hour)} label={m.hour()} />
      <span class="text-[26px] leading-none text-white">:</span>
      <Tile value={pad(parts().min)} label={m.min()} />
    </div>
  )
}
